// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-form-field {
   width: 300px
}

input {
   -webkit-box-shadow: 0 0 0 1000px white inset;
}

.error {
   font-size: 13px;
   color: #d32f2f;
   margin: 10px
}

.file-upload {
   display: none;
   overflow: hidden;
   width: 0;
   height: 0;
}

.mat-dialog-content {
   overflow: auto;
}

.imageName {
   color: cornflowerblue;
   font-style: italic;
   font-size: 12px;
   text-align: left;
}

.mat-button {
   border: 1px solid #bdc3c7;
}

.mat-dialog-title {
   font-size: 18px;
}

.body-message {
   padding: 1em 2em;
   text-align: left;
   line-height: 1.5;
   text-indent: 2em
}

.body-message img {
   height: auto;
}

li {
   list-style-position: inside;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
   cursor: pointer;
}

.err {
   color: #d32f2f;
}

.warning {
   color: #d32f2f;
   text-align: center;
   font-size: 11px;
}

.wrapper {
   overflow: hidden;
   margin: 10px
}

#one {
   float: none;
   margin-right: 0;
   width: auto;
   border: 0;
}

.two {
   background-color: white;
   overflow: auto;
   margin: 10px;
   border: 2px dashed #ccc;
   max-height: 200px;
}

.row-filename:after {
   content: "";
   display: table;
   clear: both;
}

.row-filename:hover .column-x {
   color: #d32f2f;
   display: block;
}

.column-name {
   float: left;
}

.column-x {
   margin-left: 15px;
   float: left;
   cursor: pointer;
   display: none;
}

.icon-x {
   font-size: 13px;
}

@media only screen and (max-width: 768px) {
   .body-message img {
      width: 100%;
   }

   .body-message span {
      width: 100%;
   }
}

.column {
   float: left;
   width: 50%;
   padding: 10px;
}

.row:after {
   content: "";
   display: table;
   clear: both;
}

.upload-button {
   border: 1px solid #00bcd4;
   color: #00b2c9;
   line-height: normal;
}

.upload-button i, .upload-button span {
   display: inline-block;
   vertical-align: middle;
}

.upload-button input[type=file] {
   display: none;
   overflow: hidden;
   width: 0;
   height: 0;
}

.required {
   color: #F44336;
}

.hint {
   color: #FFA726;
   font-size: 11px;
}

.inactive {
   color: #ccc;
}

.file-list {
   font-size: 12px;
   list-style: none;
   margin: 8px 0;
   padding: 0;
}

.file-list li {
   line-height: 24px;
   padding-right: 24px;
   position: relative;
}

.file-list .file-name {
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
}

.file-list .file-size {
   font-size: 11px;
}

.file-list mat-icon {
   color: #999;
   cursor: pointer;
   font-size: 20px;
   width: 20px;
   height: 20px;
   position: absolute;
   top: 2px;
   right: 0;
   opacity: 0;
   transition: opacity .1s, color .4s;
}

.file-list li:hover mat-icon {
   opacity: 1;
}

.file-list mat-icon:hover {
   color: #d32f2f;
}
`, "",{"version":3,"sources":["webpack://./src/app/account/register-etax/register-etax.component.css"],"names":[],"mappings":"AAAA;GACG;AACH;;AAEA;GACG,4CAA4C;AAC/C;;AAEA;GACG,eAAe;GACf,cAAc;GACd;AACH;;AAEA;GACG,aAAa;GACb,gBAAgB;GAChB,QAAQ;GACR,SAAS;AACZ;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,qBAAqB;GACrB,kBAAkB;GAClB,eAAe;GACf,gBAAgB;AACnB;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,gBAAgB;GAChB,gBAAgB;GAChB,gBAAgB;GAChB;AACH;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,2BAA2B;GAC3B,mBAAmB;GACnB,gBAAgB;GAChB,uBAAuB;GACvB,eAAe;AAClB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,cAAc;GACd,kBAAkB;GAClB,eAAe;AAClB;;AAEA;GACG,gBAAgB;GAChB;AACH;;AAEA;GACG,WAAW;GACX,eAAe;GACf,WAAW;GACX,SAAS;AACZ;;AAEA;GACG,uBAAuB;GACvB,cAAc;GACd,YAAY;GACZ,uBAAuB;GACvB,iBAAiB;AACpB;;AAEA;GACG,WAAW;GACX,cAAc;GACd,WAAW;AACd;;AAEA;GACG,cAAc;GACd,cAAc;AACjB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,iBAAiB;GACjB,WAAW;GACX,eAAe;GACf,aAAa;AAChB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG;MACG,WAAW;GACd;;GAEA;MACG,WAAW;GACd;AACH;;AAEA;GACG,WAAW;GACX,UAAU;GACV,aAAa;AAChB;;AAEA;GACG,WAAW;GACX,cAAc;GACd,WAAW;AACd;;AAEA;GACG,yBAAyB;GACzB,cAAc;GACd,mBAAmB;AACtB;;AAEA;GACG,qBAAqB;GACrB,sBAAsB;AACzB;;AAEA;GACG,aAAa;GACb,gBAAgB;GAChB,QAAQ;GACR,SAAS;AACZ;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,cAAc;GACd,eAAe;AAClB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,eAAe;GACf,gBAAgB;GAChB,aAAa;GACb,UAAU;AACb;;AAEA;GACG,iBAAiB;GACjB,mBAAmB;GACnB,kBAAkB;AACrB;;AAEA;GACG,mBAAmB;GACnB,gBAAgB;GAChB,uBAAuB;AAC1B;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,WAAW;GACX,eAAe;GACf,eAAe;GACf,WAAW;GACX,YAAY;GACZ,kBAAkB;GAClB,QAAQ;GACR,QAAQ;GACR,UAAU;GACV,kCAAkC;AACrC;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,cAAc;AACjB","sourcesContent":[".mat-form-field {\n   width: 300px\n}\n\ninput {\n   -webkit-box-shadow: 0 0 0 1000px white inset;\n}\n\n.error {\n   font-size: 13px;\n   color: #d32f2f;\n   margin: 10px\n}\n\n.file-upload {\n   display: none;\n   overflow: hidden;\n   width: 0;\n   height: 0;\n}\n\n.mat-dialog-content {\n   overflow: auto;\n}\n\n.imageName {\n   color: cornflowerblue;\n   font-style: italic;\n   font-size: 12px;\n   text-align: left;\n}\n\n.mat-button {\n   border: 1px solid #bdc3c7;\n}\n\n.mat-dialog-title {\n   font-size: 18px;\n}\n\n.body-message {\n   padding: 1em 2em;\n   text-align: left;\n   line-height: 1.5;\n   text-indent: 2em\n}\n\n.body-message img {\n   height: auto;\n}\n\nli {\n   list-style-position: inside;\n   white-space: nowrap;\n   overflow: hidden;\n   text-overflow: ellipsis;\n   cursor: pointer;\n}\n\n.err {\n   color: #d32f2f;\n}\n\n.warning {\n   color: #d32f2f;\n   text-align: center;\n   font-size: 11px;\n}\n\n.wrapper {\n   overflow: hidden;\n   margin: 10px\n}\n\n#one {\n   float: none;\n   margin-right: 0;\n   width: auto;\n   border: 0;\n}\n\n.two {\n   background-color: white;\n   overflow: auto;\n   margin: 10px;\n   border: 2px dashed #ccc;\n   max-height: 200px;\n}\n\n.row-filename:after {\n   content: \"\";\n   display: table;\n   clear: both;\n}\n\n.row-filename:hover .column-x {\n   color: #d32f2f;\n   display: block;\n}\n\n.column-name {\n   float: left;\n}\n\n.column-x {\n   margin-left: 15px;\n   float: left;\n   cursor: pointer;\n   display: none;\n}\n\n.icon-x {\n   font-size: 13px;\n}\n\n@media only screen and (max-width: 768px) {\n   .body-message img {\n      width: 100%;\n   }\n\n   .body-message span {\n      width: 100%;\n   }\n}\n\n.column {\n   float: left;\n   width: 50%;\n   padding: 10px;\n}\n\n.row:after {\n   content: \"\";\n   display: table;\n   clear: both;\n}\n\n.upload-button {\n   border: 1px solid #00bcd4;\n   color: #00b2c9;\n   line-height: normal;\n}\n\n.upload-button i, .upload-button span {\n   display: inline-block;\n   vertical-align: middle;\n}\n\n.upload-button input[type=file] {\n   display: none;\n   overflow: hidden;\n   width: 0;\n   height: 0;\n}\n\n.required {\n   color: #F44336;\n}\n\n.hint {\n   color: #FFA726;\n   font-size: 11px;\n}\n\n.inactive {\n   color: #ccc;\n}\n\n.file-list {\n   font-size: 12px;\n   list-style: none;\n   margin: 8px 0;\n   padding: 0;\n}\n\n.file-list li {\n   line-height: 24px;\n   padding-right: 24px;\n   position: relative;\n}\n\n.file-list .file-name {\n   white-space: nowrap;\n   overflow: hidden;\n   text-overflow: ellipsis;\n}\n\n.file-list .file-size {\n   font-size: 11px;\n}\n\n.file-list mat-icon {\n   color: #999;\n   cursor: pointer;\n   font-size: 20px;\n   width: 20px;\n   height: 20px;\n   position: absolute;\n   top: 2px;\n   right: 0;\n   opacity: 0;\n   transition: opacity .1s, color .4s;\n}\n\n.file-list li:hover mat-icon {\n   opacity: 1;\n}\n\n.file-list mat-icon:hover {\n   color: #d32f2f;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
